import { connect } from 'react-redux';

import SmsesScreen from '../components/SmsesScreen';

const mapStateToProps = (state) => {
  return {
    total: state.smses.get('total'),
    isLoading: state.smses.get('isLoading'),
  };
};

const SmsesScreenContainer = connect(mapStateToProps)(SmsesScreen);

export default SmsesScreenContainer;
